import React from 'react'
import { Header } from './Header';
import About from './About';
import Event from './Event';
import Slider from './Slider';
import Subscribe from './Subscribe';
import GalleryLatest from './GalleryLatest';
import News from './News';

export default function Home() {
    return (
        <div className='bg-[#121212]'>
            <Header />
            <div className="py-6"></div>
            {/* <About />
            <div className="py-6"></div> */}
            <Slider />
            <div className="py-6"></div>
            <Event />
            <div className="py-6"></div>
            <GalleryLatest />
            <div className="py-6"></div>
            <News />
            <div className="py-6"></div>
            {/* <Subscribe />
            <div className="py-6"></div> */}
        </div>
    )
}
